import { createGlobalStyle } from 'styled-components';
import { primitives, semantic } from '../tokens';

const GlobalStyle = createGlobalStyle`
  :root {
    --header-height: 80px;
    --announcement-height: 40px;
    --primary-blue: ${primitives.color.brand[500]};
    --accent-blue: ${primitives.color.brand[700]};
    --secondary-blue: ${primitives.color.brand[700]};
    --primary-blue-dark: ${primitives.color.brand[600]};
    --bg-light: ${primitives.color.pageBg};
    --text-black: ${primitives.color.textLegacy};
    --text-gray: ${primitives.color.textMutedLegacy};
    --text-light-gray: ${primitives.color.neutral[400]};
    --white: ${primitives.color.neutral[0]};
    --cta-green: ${primitives.color.green[500]};
    --hover-green: ${primitives.color.green[700]};
    --hover-blue: ${primitives.color.brand[600]};
    --error: ${primitives.color.red[500]};
    --border-light: ${semantic.color.border.default};
    --gray-300: ${primitives.color.neutral[300]};
    --footer-blue: ${primitives.color.footer};
    --footer-surface: ${primitives.color.footer};
    --container-width: ${semantic.space.containerMax};
    --focus-ring: ${semantic.focusRing};
    --duration-fast: ${primitives.duration.fast};
    --duration-normal: ${primitives.duration.normal};
    --ease-out: ${primitives.easing.easeOut};
    --radius-card: ${primitives.radius['2xl']};
    --section-gap: ${semantic.space.sectionGap};
    --section-gap-mobile: ${semantic.space.sectionGapMobile};
    --text-sm: ${primitives.fontSize.sm};
    --text-3xl: ${primitives.fontSize['3xl']};
    --text-4xl: ${primitives.fontSize['4xl']};
    --scrim-inner-hero: ${semantic.scrim.innerHero};
    --readable-max: ${semantic.space.readableMax};
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }
  }

  body {
    font-family: 'Work Sans', sans-serif;
    line-height: 1.5;
    color: var(--text-black);
    background: var(--bg-light);
  }

  a:focus-visible,
  button:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }

  img {
    max-width: 100%;
    height: auto;
  }

  button {
    cursor: pointer;
    font-family: inherit;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.2;
  }

  /* Utility Classes */
  .container {
    max-width: var(--container-width);
    margin: 0 auto;
    padding: 0 2rem;

    @media (max-width: 768px) {
      padding: 0 1rem;
    }
  }
`;

export default GlobalStyle;
